/* Bee 3D theme scripts. No build step. Every component re-initialises when its section reloads in the theme editor. */
(() => {
  const B = window.B3 || {};
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches || !B.animations;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const hasGsap = () => typeof window.gsap !== 'undefined';

  /* ---------- Money (Shopify money format) ---------- */
  function formatMoney(cents, format = B.moneyFormat || '${{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = (n, decimals = 2, th = ',', dec = '.') => {
      n = (Number(n) / 100).toFixed(decimals);
      const [whole, frac] = n.split('.');
      return whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (frac ? dec + frac : '');
    };
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return format;
    let v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(m[0], v);
  }
  const money = (cents) => formatMoney(cents).replace(/\.00(?!\d)/, '');

  /* ---------- Small helpers ---------- */
  function setDigits(el, str) {
    if (!el) return;
    str = String(str);
    const prev = el.textContent.replace(/\s+/g, '');
    if (prev === str) return;
    let same = 0;
    while (same < prev.length && same < str.length && prev[same] === str[same]) same++;
    el.classList.remove('pop'); el.replaceChildren();
    [...str].forEach((ch, i) => { const s = document.createElement('span'); s.className = 'd'; s.textContent = ch; if (i < same) s.dataset.same = ''; s.style.animationDelay = Math.max(0, i - same) * 40 + 'ms'; el.appendChild(s); });
    if (!reduce()) { void el.offsetWidth; el.classList.add('pop'); }
  }
  let audio = null;
  function click(strength = 0.5, pitch = 1) {
    if (!B.sound) return;
    try {
      audio = audio || new (window.AudioContext || window.webkitAudioContext)();
      const t = audio.currentTime, o = audio.createOscillator(), g = audio.createGain();
      o.frequency.setValueAtTime(1900 * pitch, t); o.frequency.exponentialRampToValueAtTime(700 * pitch, t + 0.03);
      g.gain.setValueAtTime(0.12 * strength, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.05);
      o.connect(g).connect(audio.destination); o.start(t); o.stop(t + 0.06);
    } catch (e) { /* sound is optional */ }
  }
  let toastT;
  function toast(msg) {
    const el = $('.toast'); if (!el) return;
    el.hidden = false; el.textContent = msg; el.classList.remove('is-on'); void el.offsetWidth; el.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => el.classList.remove('is-on'), 3200);
  }

  /* ---------- Drawers ---------- */
  let opener = null;
  function openDrawer(d) {
    if (!d) return;
    opener = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); d.inert = false;
    document.body.classList.add('has-drawer');
    const btn = d.querySelector('[data-menu-open]'); if (btn) btn.setAttribute('aria-expanded', 'true');
    setTimeout(() => { const p = d.querySelector('.drawer-panel'); p && p.focus(); }, 60);
  }
  function closeDrawer(d) {
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); d.inert = true;
    if (!$('.drawer.is-open')) document.body.classList.remove('has-drawer');
    $$('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    opener && opener.focus && opener.focus();
  }
  $$('.drawer').forEach((d) => { if (!d.classList.contains('is-open')) d.inert = true; });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(e.target.closest('.drawer')); return; }
    const m = e.target.closest('[data-menu-open]');
    if (m) { openDrawer($('#MenuDrawer')); return; }
    const bag = e.target.closest('[data-bag-open]');
    if (bag && B.cartType === 'drawer' && $('#CartDrawer') && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer($('#CartDrawer')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });

  /* ---------- Cart ---------- */
  function paintCart(cart) {
    $$('[data-cart-count]').forEach((el) => setDigits(el, cart.item_count));
    $$('[data-cart-total]').forEach((el) => setDigits(el, money(cart.total_price)));
    paintMeters(cart.total_price);
  }
  function paintMeters(total) {
    const f = B.freeShip || {}; if (!f.on || !f.threshold) return;
    const left = Math.max(0, f.threshold - total), pct = Math.min(1, total / f.threshold);
    $$('[data-meter]').forEach((m) => {
      const t = m.querySelector('[data-meter-text]'), fill = m.querySelector('[data-meter-fill]');
      if (fill) fill.style.transform = `scaleX(${pct})`;
      m.classList.toggle('is-done', left === 0 && total > 0);
      if (!t) return;
      if (total === 0) t.textContent = (f.start || '').replace('[threshold]', money(f.threshold));
      else if (left === 0) t.textContent = f.done || '';
      else t.textContent = (f.progress || '').replace('[remaining]', formatMoney(left));
    });
  }
  async function refreshCart(sectionsHtml) {
    if (sectionsHtml && sectionsHtml['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sectionsHtml['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('#CartDrawerInner'), cur = $('#CartDrawerInner');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    const cart = await fetch(B.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    paintCart(cart);
    return cart;
  }
  async function addToCart(body, fromEl) {
    const isForm = body instanceof FormData;
    if (isForm) { body.append('sections', 'cart-drawer'); body.append('sections_url', location.pathname); }
    else body = JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: location.pathname });
    const res = await fetch(B.routes.cartAdd + '.js', { method: 'POST', headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' }, body });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || (B.strings && B.strings.error));
    if (B.cartType === 'page') { location.href = B.routes.cart; return; }
    if (fromEl) fly(fromEl);
    await refreshCart(data.sections);
    openDrawer($('#CartDrawer'));
    document.dispatchEvent(new CustomEvent('b3:cart:added', { detail: data }));
  }
  async function changeLine(key, quantity, lineEl) {
    lineEl && lineEl.classList.add('is-busy');
    try {
      const res = await fetch(B.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer', sections_url: location.pathname }) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message);
      if ($('[data-cart-page]')) { location.reload(); return; }
      await refreshCart(data.sections);
    } catch (err) { toast(err.message || (B.strings && B.strings.error)); lineEl && lineEl.classList.remove('is-busy'); }
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('.cart-line [data-qty]');
    if (!q) return;
    const line = q.closest('.cart-line');
    changeLine(line.dataset.key, Math.max(0, parseInt(q.dataset.qty, 10)), line);
  });
  let noteT;
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(noteT);
    noteT = setTimeout(() => fetch(B.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) }), 500);
  });
  function fly(fromEl) {
    const target = $$('[data-bag-open]').find((el) => el.offsetParent !== null);
    const img = fromEl.querySelector('img');
    if (reduce() || !hasGsap() || !target || !img) return;
    const a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width) return;
    const g = img.cloneNode(); g.removeAttribute('srcset'); g.removeAttribute('sizes'); g.removeAttribute('style'); g.className = 'fly';
    const size = Math.min(a.width, 120);
    Object.assign(g.style, { left: a.left + a.width / 2 - size / 2 + 'px', top: a.top + a.height / 2 - size / 2 + 'px', width: size + 'px', height: size + 'px' });
    document.body.appendChild(g);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    gsap.timeline({ onComplete: () => g.remove() })
      .to(g, { x: dx, duration: 0.7, ease: 'power1.inOut' }, 0)
      .to(g, { y: dy, duration: 0.7, ease: 'back.in(1.6)' }, 0)
      .to(g, { scale: 0.18, borderRadius: '50%', duration: 0.7, ease: 'power2.in' }, 0)
      .to(g, { opacity: 0, duration: 0.15 }, 0.58);
  }

  /* ---------- Sliding tabs ---------- */
  function seg(host, onChange) {
    const track = host.querySelector('.seg-track'), ind = host.querySelector('.seg-ind');
    const buttons = $$('button', track);
    const place = (animate = true) => {
      const b = buttons.find((x) => x.getAttribute('aria-pressed') === 'true') || buttons[0];
      if (!b || !ind) return;
      if (!animate) ind.style.transition = 'none';
      ind.style.width = b.offsetWidth + 'px'; ind.style.transform = `translateX(${b.offsetLeft - 4}px)`;
      if (!animate) { void ind.offsetWidth; ind.style.transition = ''; }
    };
    const set = (v, fire = true) => {
      buttons.forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.v === v)));
      place(); fire && onChange && onChange(v);
      const b = buttons.find((x) => x.dataset.v === v);
      if (b && host.scrollWidth > host.clientWidth) host.scrollTo({ left: b.offsetLeft - (host.clientWidth - b.offsetWidth) / 2, behavior: reduce() ? 'auto' : 'smooth' });
    };
    track.addEventListener('click', (e) => { const b = e.target.closest('button'); if (b) { click(0.4, 1.2); set(b.dataset.v); } });
    new ResizeObserver(() => place(false)).observe(host);
    if (document.fonts) document.fonts.ready.then(() => place(false));
    requestAnimationFrame(() => place(false));
    return { set, get: () => (buttons.find((x) => x.getAttribute('aria-pressed') === 'true') || {}).dataset?.v };
  }
  function rangePaint(input) {
    const min = +input.min, max = +input.max, v = +input.value;
    input.style.setProperty('--p', ((v - min) / (max - min || 1)) * 100 + '%');
  }

  /* ---------- Announcement: split-flap ---------- */
  function initFlap(el) {
    const words = el.dataset.words.split('|||').map((w) => w.trim().toUpperCase()).filter(Boolean);
    if (!words.length) return;
    const len = Math.max(...words.map((w) => w.length));
    const tiles = [];
    el.replaceChildren();
    for (let i = 0; i < len; i++) { const t = document.createElement('span'); t.className = 't'; el.appendChild(t); tiles.push(t); }
    const CH = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789$';
    const show = (w, animate) => {
      el.setAttribute('aria-label', w);
      tiles.forEach((t, i) => {
        const ch = w[i] || ' ';
        const fin = () => { t.textContent = ch === ' ' ? '' : ch; t.classList.toggle('sp', ch === ' '); };
        if (!animate) return fin();
        let n = 0; const flips = 4 + (i % 3);
        setTimeout(function tick() { if (n++ < flips) { t.textContent = CH[Math.floor(Math.random() * CH.length)]; t.classList.remove('sp'); setTimeout(tick, 55); } else fin(); }, i * 30);
      });
    };
    let k = 0; show(words[0], false);
    if (words.length < 2) return;
    const ms = (+el.dataset.speed || 4) * 1000;
    setInterval(() => { if (document.hidden) return; k = (k + 1) % words.length; show(words[k], !reduce()); }, ms);
  }
  function initRotate(el) {
    const items = $$('.announce-item', el); if (items.length < 2) return;
    let k = 0; const ms = (+el.dataset.speed || 4) * 1000;
    setInterval(() => { items[k].classList.remove('is-on'); k = (k + 1) % items.length; items[k].classList.add('is-on'); }, ms);
  }

  /* ---------- Shop grid ---------- */
  function initShop(root) {
    const grid = $('[data-grid]', root); if (!grid) return;
    const cards = $$('.pc[data-price]', grid), empty = $('[data-empty]', grid);
    const state = { cat: '', max: null, sort: root.dataset.sortDefault || 'featured' };
    const catBtns = $$('[data-cat]', root);
    const spend = $('[data-spend]', root), spendInput = spend && $('input', spend), spendVal = spend && $('[data-spend-val]', spend);
    const sortHost = $('[data-sort]', root);
    let first = true;
    const inCat = (c, cat) => !cat || c.dataset.cols.includes(' ' + cat + ' ');
    const inBudget = (c) => state.max == null || +c.dataset.price <= state.max * 100;
    const sorters = {
      featured: (a, b) => a.dataset.index - b.dataset.index,
      low: (a, b) => a.dataset.price - b.dataset.price || a.dataset.index - b.dataset.index,
      high: (a, b) => b.dataset.price - a.dataset.price || a.dataset.index - b.dataset.index,
      new: (a, b) => b.dataset.created - a.dataset.created,
      az: (a, b) => a.dataset.title.localeCompare(b.dataset.title)
    };
    function apply() {
      const list = cards.filter((c) => inCat(c, state.cat) && inBudget(c)).sort(sorters[state.sort] || sorters.featured);
      const animate = !first && !reduce() && window.Flip;
      const flipState = animate ? Flip.getState(cards) : null;
      list.forEach((c) => grid.insertBefore(c, empty));
      cards.forEach((c) => { c.hidden = !list.includes(c); });
      if (empty) empty.hidden = list.length > 0;
      if (flipState) Flip.from(flipState, { duration: 0.6, ease: 'power3.inOut', absolute: true, simple: true, stagger: 0.01,
        onEnter: (els) => gsap.fromTo(els, { opacity: 0, scale: 0.88 }, { opacity: 1, scale: 1, duration: 0.45, delay: 0.12, stagger: 0.03, ease: 'back.out(1.4)', clearProps: 'opacity,scale,transform' }),
        onLeave: (els) => gsap.to(els, { opacity: 0, scale: 0.88, duration: 0.28, ease: 'power2.in' }) });
      first = false;
      setDigits($('[data-shown]', root), list.length);
      catBtns.forEach((b) => { const n = cards.filter((c) => inCat(c, b.dataset.cat) && inBudget(c)).length; const s = $('[data-count]', b); if (s) s.textContent = n; b.classList.toggle('is-empty', n === 0); });
    }
    catBtns.forEach((b) => b.addEventListener('click', () => { state.cat = b.dataset.cat; catBtns.forEach((x) => x.setAttribute('aria-pressed', String(x === b))); click(0.4, 1); apply(); }));
    if (spendInput) {
      const paint = () => { rangePaint(spendInput); const v = +spendInput.value, isAny = v >= +spendInput.max; state.max = isAny ? null : v; setDigits(spendVal, isAny ? spend.dataset.any : money(v * 100)); spendInput.setAttribute('aria-valuetext', isAny ? spend.dataset.any : money(v * 100)); };
      let last = spendInput.value;
      spendInput.addEventListener('input', () => { if (spendInput.value !== last) { last = spendInput.value; click(0.25, 1.4); paint(); apply(); } });
      paint();
    }
    if (sortHost) { const s = seg(sortHost, (v) => { state.sort = v; apply(); }); s.set(state.sort, false); }
    const reset = $('[data-reset]', root);
    if (reset) reset.addEventListener('click', () => { state.cat = ''; catBtns.forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.cat === ''))); if (spendInput) { spendInput.value = spendInput.max; spendInput.dispatchEvent(new Event('input')); } apply(); });
    apply();
  }

  /* ---------- Conveyor hero ---------- */
  const RING = '<svg viewBox="0 0 100 100" aria-hidden="true"><polygon points="50,4 90,27 90,73 50,96 10,73 10,27" fill="none" stroke="#1A1A1A" stroke-width="4" stroke-linejoin="round" stroke-dasharray="10 9" opacity="0.55"/></svg>';
  function printOne(el, dur) {
    return new Promise((resolve) => {
      el.classList.add('is-started');
      if (reduce() || !hasGsap()) { el.classList.add('is-done'); return resolve(); }
      const img = $('img.photo', el), spin = $('.spin', el), gantry = $('.gantry', el), head = $('.head', el), st = { p: 0 };
      gsap.timeline({ onComplete: () => { el.classList.add('is-done'); resolve(); } })
        .to(spin, { opacity: 1, scale: 1, duration: 0.25, ease: 'power2.out', startAt: { scale: 0.8 } })
        .to(spin, { opacity: 0, scale: 0.85, duration: 0.25, ease: 'power2.in' }, '+=0.55')
        .set(gantry, { opacity: 1, top: '100%' })
        .to(st, { p: 1, duration: dur, ease: 'none', onUpdate() {
          const p = Math.round(st.p * 60) / 60;
          img.style.clipPath = `inset(${(1 - p) * 100}% 0 0 0)`; gantry.style.top = (1 - p) * 100 + '%';
          head.style.transform = `translateX(${Math.sin(p * 60) * el.clientWidth * 0.32}px)`;
        } })
        .to(head, { x: () => -el.clientWidth * 0.75, duration: 0.45, ease: 'power2.in' })
        .to(gantry, { opacity: 0, duration: 0.25 }, '<0.2');
    });
  }
  function initConveyor(belt) {
    let items = [];
    try { items = JSON.parse($('[data-items]', belt).textContent); } catch (e) { return; }
    if (!items.length) return;
    const track = $('[data-track]', belt), line = $('.cv-belt', belt), made = belt.closest('section').querySelector('[data-made]');
    const spinner = belt.dataset.spinner, prices = belt.dataset.prices === 'true';
    const speed = +belt.dataset.speed || 1.6, pause = (+belt.dataset.pause || 0) * 1000;
    let k = 0, count = 0, running = true, busy = false, bx = 0;
    const tw = () => { const t = track.firstElementChild; return t ? t.offsetWidth : 120; };
    const slots = () => Math.ceil(belt.clientWidth / (tw() + 14)) + 1;
    const tile = (done) => {
      const p = items[k++ % items.length];
      const a = document.createElement('a'); a.className = 'cv-tile' + (done ? ' ready' : ''); a.href = p.url; a.setAttribute('aria-label', `${p.title}, ${p.price}`);
      a.innerHTML = `<span class="pt${done ? ' is-started is-done' : ''}">${p.img ? `<img class="photo" src="${p.img}" alt="" draggable="false" loading="lazy">` : ''}<span class="spin">${RING}<img src="${spinner}" alt=""></span><span class="gantry"><span class="head"><span class="tip"></span></span></span></span>${prices ? `<span class="cv-price">${p.price}</span>` : ''}`;
      return a;
    };
    track.replaceChildren(tile(true));
    while (track.children.length < slots() - 1) track.appendChild(tile(true));
    if (reduce() || !hasGsap()) return;
    async function step() {
      if (busy || !running || !belt.isConnected) return; busy = true;
      const t = tile(false); track.appendChild(t);
      const d = tw() + 14; bx -= d;
      gsap.to(line, { backgroundPosition: `${bx}px 0px`, duration: 0.9, ease: 'power2.inOut' });
      await new Promise((r) => gsap.fromTo(track, { x: d }, { x: 0, duration: 0.9, ease: 'power2.inOut', onComplete: r }));
      await printOne($('.pt', t), speed);
      t.classList.add('ready'); count++; setDigits(made, count);
      while (track.children.length > slots() + 1) track.firstElementChild.remove();
      busy = false; setTimeout(step, pause);
    }
    new IntersectionObserver(([e]) => { running = e.isIntersecting && !document.hidden; if (running) step(); }).observe(belt);
    document.addEventListener('visibilitychange', () => { running = !document.hidden; if (running) step(); });
  }

  /* ---------- Mystery box ---------- */
  function initMystery(el) {
    let variants = [];
    try { variants = JSON.parse($('[data-variants]', el).textContent); } catch (e) { return; }
    const sec = el.closest('section');
    const whoIdx = +el.dataset.whoIndex, spendIdx = +el.dataset.spendIndex;
    const num = (s) => parseFloat(String(s).replace(/[^0-9.]/g, '')) || 0;
    const steps = (el.dataset.steps || '').split(/[\n,]+/).map((l) => l.split(':').map(num)).filter((p) => p.length === 2 && p[0] > 0).sort((a, b) => a[0] - b[0]);
    const valueOf = (pay) => {
      if (!steps.length) return pay;
      if (pay <= steps[0][0]) return Math.floor((pay * steps[0][1] / steps[0][0]) / 5) * 5;
      for (let i = 1; i < steps.length; i++) { const [p0, v0] = steps[i - 1], [p1, v1] = steps[i]; if (pay <= p1) return Math.floor((v0 + ((pay - p0) / (p1 - p0)) * (v1 - v0)) / 5) * 5; }
      const [pl, vl] = steps[steps.length - 1]; return Math.floor((pay * vl / pl) / 5) * 5;
    };
    const spendVals = [...new Set(variants.map((v) => v.options[spendIdx]))].sort((a, b) => num(a) - num(b));
    const input = $('[data-m-range] input', el), top = $('[data-pay-top]', el);
    input.max = Math.max(0, spendVals.length - 1);
    $('[data-min]', el).textContent = spendVals[0] || ''; $('[data-max]', el).textContent = spendVals[spendVals.length - 1] || '';
    const whoHost = $('[data-who]', el);
    let who = whoHost ? (($$('button', whoHost).find((b) => b.getAttribute('aria-pressed') === 'true') || {}).dataset || {}).v : null;
    if (whoHost) seg(whoHost, (v) => { who = v; wiggle(); paint(); });
    const box = $('[data-box], .box', sec), lid = $('[data-lid]', sec);
    const ship = $('[data-ship]', el), shipAt = +el.dataset.shipAt || 0;
    const btn = $('[data-m-add]', el), err = $('[data-m-error]', el);
    const find = () => variants.find((v) => v.options[spendIdx] === spendVals[+input.value] && (whoIdx < 0 || v.options[whoIdx] === who));
    function wiggle() { if (reduce() || !lid || !hasGsap()) return; gsap.fromTo(lid, { rotation: 0 }, { keyframes: [{ rotation: -6, y: -8, duration: 0.12 }, { rotation: 5, y: -4, duration: 0.12 }, { rotation: 0, y: 0, duration: 0.3, ease: 'back.out(3)' }] }); }
    let wasFree = false, last = input.value;
    function paint() {
      rangePaint(input);
      const v = find(), payCents = v ? v.price : num(spendVals[+input.value]) * 100, pay = payCents / 100, val = valueOf(pay);
      setDigits(top, money(payCents)); setDigits($('[data-pay]', el), money(payCents)); setDigits($('[data-value]', el), money(val * 100)); setDigits($('[data-worth]', sec), money(val * 100));
      btn.textContent = btn.dataset.label.replace('[price]', money(payCents));
      btn.disabled = !v || !v.available; if (err) err.hidden = !!(v && v.available);
      input.setAttribute('aria-valuetext', money(payCents));
      if (ship && shipAt) { const free = pay >= shipAt; ship.classList.toggle('is-on', free); $('span', ship).textContent = (free ? ship.dataset.above : ship.dataset.below).replace('[threshold]', money(shipAt * 100)); if (free && !wasFree) wiggle(); wasFree = free; }
      if (box && !reduce() && hasGsap()) gsap.to(box, { scale: 0.86 + (+input.value / Math.max(1, spendVals.length - 1)) * 0.24, duration: 0.5, ease: 'back.out(1.6)' });
    }
    input.addEventListener('input', () => { if (input.value !== last) { last = input.value; click(0.25, 1.4); paint(); } });
    btn.addEventListener('click', async () => {
      const v = find(); if (!v || !v.available) return;
      btn.disabled = true;
      try { await addToCart({ items: [{ id: v.id, quantity: 1 }] }, $('[data-boxstage]', sec)); if (lid && hasGsap() && !reduce()) gsap.timeline().to(lid, { y: -40, rotation: -14, duration: 0.25, ease: 'power2.out' }).to(lid, { y: 0, rotation: 0, duration: 0.5, ease: 'bounce.out' }); }
      catch (e) { toast(e.message); }
      btn.disabled = false;
    });
    paint();
  }

  /* ---------- Product page ---------- */
  function initGallery(g) {
    const stage = $('[data-stage]', g), items = $$('.stage-item', stage), thumbs = $$('[data-thumbs] button', g);
    const show = (id) => {
      const i = items.findIndex((x) => x.dataset.mediaId === String(id)); if (i < 0) return;
      items.forEach((x, j) => { x.classList.toggle('is-on', j === i); const v = $('video', x); if (v) { if (j === i) v.play().catch(() => {}); else v.pause(); } });
      thumbs.forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.mediaId === String(id))));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.mediaId)));
    $$('video', stage).forEach((v) => { v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); if (reduce()) { v.removeAttribute('autoplay'); v.pause(); } });
    let sx = null;
    stage.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') sx = e.clientX; });
    stage.addEventListener('pointerup', (e) => {
      if (sx == null) return; const dx = e.clientX - sx; sx = null; if (Math.abs(dx) < 40) return;
      const i = items.findIndex((x) => x.classList.contains('is-on')), n = (i + (dx < 0 ? 1 : -1) + items.length) % items.length;
      show(items[n].dataset.mediaId);
    });
    g.b3show = show;
  }
  function initProduct(sec) {
    let variants = [];
    try { variants = JSON.parse($('[data-variants]', sec).textContent); } catch (e) { return; }
    const form = $('form[data-product-form]', sec); if (!form) return;
    const idInput = $('[data-variant-id]', form), gallery = $('[data-gallery]', sec);
    const fieldsets = $$('[data-option-index]', sec);
    const addBtns = $$('[data-add]', sec), errEl = $('[data-form-error]', sec);
    const current = () => variants.find((v) => String(v.id) === idInput.value) || variants[0];
    function update() {
      const chosen = [];
      fieldsets.forEach((fs) => { const c = $('input:checked', fs); chosen[+fs.dataset.optionIndex] = c ? c.value : null; const lab = $('[data-selected-value]', fs); if (lab && c) lab.textContent = c.value; });
      const v = variants.find((x) => x.options.every((o, i) => chosen[i] == null || o === chosen[i]));
      if (!v) { addBtns.forEach((b) => { b.disabled = true; $('[data-add-label]', b).textContent = B.strings.unavailable; }); return; }
      idInput.value = v.id;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      setDigits($('[data-price-now]', sec), money(v.price));
      const was = $('[data-price-was]', sec); if (was) { was.hidden = !(v.compare_at_price > v.price); was.textContent = money(v.compare_at_price || 0); }
      const q = $('[data-quarter]', sec); if (q) q.textContent = formatMoney(Math.floor(v.price / 4));
      const sp = $('[data-sticky-price]', sec); if (sp) sp.textContent = money(v.price);
      addBtns.forEach((b) => { b.disabled = !v.available; const l = $('[data-add-label]', b); l.textContent = v.available ? b.dataset.label + (b.dataset.showPrice === 'true' ? ' · ' + money(v.price * qty()) : '') : B.strings.soldOut; });
      if (v.featured_media && gallery && gallery.b3show) gallery.b3show(v.featured_media.id);
    }
    const qtyInput = $('[data-qty-input]', sec);
    const qty = () => Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
    sec.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) { click(0.4, 1.2); update(); } if (e.target === qtyInput) update(); });
    $$('[data-step]', sec).forEach((b) => b.addEventListener('click', () => { qtyInput.value = Math.max(1, qty() + +b.dataset.step); update(); }));
    form.addEventListener('submit', async (e) => {
      if (B.cartType === 'page') return;
      e.preventDefault();
      if (errEl) errEl.hidden = true;
      addBtns.forEach((b) => b.setAttribute('aria-busy', 'true'));
      try { await addToCart(new FormData(form), gallery || sec); }
      catch (err) { if (errEl) { errEl.textContent = err.message; errEl.hidden = false; } else toast(err.message); }
      addBtns.forEach((b) => b.removeAttribute('aria-busy'));
    });
    const sticky = $('[data-sticky-buy]', sec), buy = $('[data-buy]', sec);
    if (sticky && buy) {
      let ticking = false;
      const check = () => { ticking = false; const on = buy.getBoundingClientRect().bottom < 0; if (on === sticky.classList.contains('is-on')) return; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', String(!on)); $('[data-sticky-add]', sticky).tabIndex = on ? 0 : -1; };
      addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      $('[data-sticky-add]', sticky).addEventListener('click', () => { if (current().available) form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
    if (fieldsets.length) update();
  }

  /* ---------- Accordions ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.acc-h button'); if (!b) return;
    const item = b.closest('.acc-item'), open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open); b.setAttribute('aria-expanded', String(open));
  });

  /* ---------- Photo carousel ---------- */
  function initReel(sec) {
    const track = $('[data-track]', sec), figs = $$('.reel-item', track), dots = $('[data-dots]', sec);
    if (!figs.length) return;
    if (dots) dots.innerHTML = figs.map(() => '<i></i>').join('');
    const cur = () => { const x = track.scrollLeft; let best = 0; figs.forEach((f, i) => { if (Math.abs(f.offsetLeft - figs[0].offsetLeft - x) < Math.abs(figs[best].offsetLeft - figs[0].offsetLeft - x)) best = i; }); return best; };
    const go = (i) => { i = (i + figs.length) % figs.length; track.scrollTo({ left: figs[i].offsetLeft - figs[0].offsetLeft, behavior: reduce() ? 'auto' : 'smooth' }); };
    const paintDots = () => { if (!dots) return; const c = cur(); [...dots.children].forEach((d, i) => d.classList.toggle('is-on', i === c)); };
    track.addEventListener('scroll', () => requestAnimationFrame(paintDots), { passive: true }); paintDots();
    let timer = null; const stop = () => { clearInterval(timer); timer = null; };
    $('[data-prev]', sec).addEventListener('click', () => { stop(); go(cur() - 1); });
    $('[data-next]', sec).addEventListener('click', () => { stop(); go(cur() + 1); });
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { stop(); go(cur() + 1); } if (e.key === 'ArrowLeft') { stop(); go(cur() - 1); } });
    let down = null;
    track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; stop(); down = { x: e.clientX, l: track.scrollLeft }; track.classList.add('is-drag'); track.setPointerCapture(e.pointerId); });
    track.addEventListener('pointermove', (e) => { if (down) track.scrollLeft = down.l - (e.clientX - down.x); });
    const up = () => { if (!down) return; down = null; track.classList.remove('is-drag'); go(cur()); };
    track.addEventListener('pointerup', up); track.addEventListener('pointercancel', up);
    const secs = +sec.dataset.auto || 0;
    if (secs > 0 && !reduce() && !window.Shopify?.designMode) { timer = setInterval(() => go(cur() + 1), secs * 1000); ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => track.addEventListener(ev, stop, { passive: true })); }
    sec.b3go = go; sec.b3figs = figs;
  }

  /* ---------- Related products ---------- */
  async function initRelated(el) {
    if (el.dataset.loaded) return;
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-related]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; el.dataset.loaded = '1'; }
    } catch (e) { /* recommendations are optional */ }
  }

  /* ---------- Reveal on scroll ---------- */
  const revealIO = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } }), { rootMargin: '0px 0px -10% 0px' }) : null;

  /* ---------- Init (and re-init in the theme editor) ---------- */
  function init(root = document) {
    $$('[data-flap]', root).forEach(initFlap);
    $$('[data-rotate]', root).forEach(initRotate);
    $$('[data-shop]', root).forEach(initShop);
    $$('[data-conveyor]', root).forEach(initConveyor);
    $$('[data-mystery]', root).forEach(initMystery);
    $$('[data-gallery]', root).forEach(initGallery);
    $$('[data-product-section]', root).forEach(initProduct);
    $$('[data-reel]', root).forEach(initReel);
    $$('[data-related]', root).forEach(initRelated);
    if (document.body.classList.contains('reveal-on') && revealIO) $$('.section-pad', root).forEach((s) => revealIO.observe(s));
    if (root === document) {
      fetch(B.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then(paintCart).catch(() => {});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const sec = e.target.closest('[data-reel]');
    if (sec && sec.b3go) sec.b3go(sec.b3figs.indexOf(e.target));
    const acc = e.target.closest('.acc-item'); if (acc) acc.classList.add('is-open');
  });
  window.B3.formatMoney = formatMoney; window.B3.addToCart = addToCart; window.B3.openCart = () => openDrawer($('#CartDrawer'));
})();
